/* REVIEW SOFTSKILL COURSE USER */
export const REVIEW_SOFTSKILL_COURSE_USER = "REVIEW_SOFTSKILL_COURSE_USER"
export const REVIEW_SOFTSKILL_COURSE_USER_SUCCESS =
  "REVIEW_SOFTSKILL_COURSE_USER_SUCCESS"
export const REVIEW_SOFTSKILL_COURSE_USER_CLEAN =
  "REVIEW_SOFTSKILL_COURSE_USER_CLEAN"
export const REVIEW_SOFTSKILL_COURSE_USER_ERROR =
  "REVIEW_SOFTSKILL_COURSE_USER_ERROR"
